import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';

interface PutUpdateHasCloudOperationParams {
  cityId: string;
  hasCloudOperationOnCity: boolean;
}

const putUpdateHasCloudOperation = async ({
  cityId,
  hasCloudOperationOnCity,
}: PutUpdateHasCloudOperationParams) =>
  apiClient
    .put(`/municipios/${cityId}/has-cloud-operation`, {
      hasCloudOperationOnCity,
    })
    .then(response =>
      handleResponseSuccess(
        response,
        'Operação nuvem para parceiros atualizada com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível atualizar a operação nuvem para parceiros.',
      ),
    );

export const useUpdateHasCloudOperation = () => {
  return useMutation({
    mutationFn: putUpdateHasCloudOperation,
  });
};
